import { IService } from 'core/interfaces/Service'
import { ServiceCard } from 'lauria/components/applications/ServiceCard'
import { ApplicationForm } from 'lauria/hooks/useEditApplication'
import React from 'react'
import { FieldError, UseFormRegister } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

export const ServiceCardList: React.FC<{
  services: IService[]
  selectedService: IService | null
  handleSelectService: (service: IService) => void
  register: UseFormRegister<ApplicationForm>
  error: FieldError | undefined
}> = ({ services, selectedService, handleSelectService, register, error }) => {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col justify-center items-center py-[20px] border-b border-gray-1200">
      <div className="flex flex-row h-[45px] items-center text-gray-1325 text-[16px] font-medium">
        {t('applications.form.cardServiceLabel')}
      </div>
      <div className="service-card-list">
        {services.map((service, index) => (
          <ServiceCard
            service={service}
            key={index}
            isSelected={selectedService?.id === service.id}
            onClick={handleSelectService}
            error={error}
          />
        ))}
        <input type="hidden" {...register('idService', { required: true })} />
      </div>
      {error?.type === 'required' && (
        <p className="form-error">
          {t('applications.form.errors.selectService')}
        </p>
      )}
    </div>
  )
}
